import { Injectable } from '@angular/core';
import * as _ from "lodash";

export interface IHistoryCard{
  card_id: number,
  type_id: number,
  name: string,
  level: number 
}

export interface ILevelRating{
  level: number,
  rating: number
}

export interface IRQCards{
  typeId: number,
  levels: Array<ILevelRating>
}

@Injectable({
  providedIn: 'root'
})


export class CardHictoryPlayer {
  playerHistory: Array<IHistoryCard> = [];
  private objectRQCards: Object = {};
  private RQCards: Array<IRQCards>;
  countCard:IRQCards;

  initForOne(){
    this.initData();
    this.parseObjectToArray();
  }

  private initData(){
    let InfoRQ = JSON.parse(sessionStorage.getItem("QuestInfo") as string);
    this.objectRQCards = InfoRQ.cards_by_difficulty;
  }

  private parseObjectToArray(){
    this.RQCards = Object.keys(this.objectRQCards).map(key => ({
      typeId: parseInt(key),
      // @ts-ignore
      levels: Object.keys(this.objectRQCards[key]).map(item =>({
        level: parseInt(item),
        // @ts-ignore
        rating: this.objectRQCards[key][item]
      }))
    }));
  }

  setObjectRQCards(obj: any){
    this.objectRQCards = obj;
  }

  initForMany(){
    this.parseObjectToArray();
  }

  clearHistory(){
    this.playerHistory = [];
  }

  addCardHistory(card: IHistoryCard){
    if( _.isEmpty(this.findCard(card)) ){
      
      this.playerHistory.push(card);
    }
  }

  findCard(card: IHistoryCard){
    let result = this.playerHistory.find(item => item.card_id === card.card_id) ?? [];
    return result;
  }

  findType(typeId: number){
    this.countCard = this.RQCards.find(item => item.typeId === typeId) as IRQCards ?? [];
  }
    
  findLevel(level: number){
    let res = this.countCard.levels.find(item => item.level === level) ?? [];
    return res;
  }

  countCardLevel(type_id: number, level: number): number{
    let result = this.playerHistory.filter((item: IHistoryCard)=> item.type_id === type_id && item.level === level);
    return result.length || 0;
  }

  allCoundCardLevel(type_id: number, level: number):number{
    this.findType(type_id);
    let allLevelCard:ILevelRating = this.findLevel(level) as ILevelRating;
    return allLevelCard.rating
  }

  countReverse(type_id: number, level: number):number{
    this.findType(type_id);
    let allLevelCard:ILevelRating = this.findLevel(level) as ILevelRating;
    let countCard = this.countCardLevel(type_id, level);
    return allLevelCard.rating - countCard + 1;
  }


  
}
